<template>
  <div
    class="fontSelect"
    data-test="fontSelect"
    @click="toggleDropdown"
  >
    <button
      type="button"
      class="btn btn-block btn-secondary dropdown-toggle fontSelect__button"
      :class="sizeClass"
      :disabled="disabled"
    >
      {{ activeFont.font||'Select a font' }}
    </button>
    <div
      class="fontSelect__results"
      data-test="fontSelect-results"
      v-if="isOpen"
    >
      <ul
        class="fontSelect__list"
        data-test="fontSelect-list"
        ref="ul"
      >
        <li
          ref="li"
          data-test="fontSelect-item"
          v-for="(family, key) in results"
          :key="key"
          @mousedown.prevent="setResult(family)"
          class="fontSelect__result px-3 py-2"
          :style="getBackgroundStyles(family)"
        />
        <li
          v-if="!results.length"
          data-test="fontSelect-item-not-found"
          class="px-3 py-2"
        >
          No results found
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import googleFonts from '@/fonts';

export default {
  name: 'BaseFontSelect',
  props: {
    value: {
      type: [String, Object],
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      activeFont: '',
      activeIndex: null,
      moveListBy: '0px',
      isFocused: false,
      wasClosed: false,
    };
  },
  computed: {
    results() {
      const categories = ['display', 'sans-serif', 'serif', 'monospace'];
      const subset = 'latin-ext';
      const results = googleFonts
        .filter((item) => categories.indexOf(item.category) !== -1)
        .filter((item) => ((item.subsets.includes(subset)) ? item : null));
      return results.map((item) => ({
        font: item.family,
        category: item.category,
        index: item.alphaIndex,
      }));
    },
    sizeClass() {
      if (!this.hasSize) return '';
      return `btn-${this.size}`;
    },
    hasSize() {
      return this.size !== '';
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
      if (this.isOpen) this.$emit('focus');
      else this.$emit('blur');
    },
    setResult(result) {
      this.activeFont = result;
      this.emitValue(result.font);
      this.isOpen = false;
      this.wasClosed = true;
    },
    emitValue(result) {
      const newValue = result;
      this.$emit('input', newValue);
      this.$emit('change');
    },
    getBackgroundStyles(item) {
      const letter = item.font.substring(0, 1).toLowerCase();
      const offset = item.index * 40 - 2;
      return {
        'background-image': `url(/images/font-gifs/font-list-${letter}.gif`,
        'background-position': `0 -${offset}px`,
      };
    },
    // onClickOutside() {
    //   this.isOpen = false;
    // },
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
    this.activeFont = this.results.find((obj) => obj.font === this.value) || '';
  },
  destroyed() {
    document.removeEventListener('click', this.onClickOutside);
  },
};
</script>
<style lang="scss">
.fontSelect {
  position: relative;
  &__button {
    // min-width: 180px;
  }
  &__results {
    max-width: 300px;
    max-height: 200px;
    position: absolute;
    border: 1px solid #eeeeee;
    z-index: 10;
    background: white;
    width: 100%;
    overflow: auto;
  }

  &__list {
    padding: 0;
    margin: 0;
    position: relative;
  }

  &__result {
    list-style: none;
    text-align: left;
    line-height: 40px;
    height: 40px;
    width: auto;
    padding: 0;
    margin: 0;
    overflow: hidden;
    box-sizing: border-box;
    cursor: pointer;

    &.is-active,
    &:hover {
      background-color: $smartology-teal;
      color: white;
    }
  }
}
</style>
